// extracted by mini-css-extract-plugin
export var clauseRow = "_br-6";
export var emptyState = "_br-d";
export var filterContent = "_br-a";
export var filterGroup = "_br-1";
export var filterGroupContainer = "_br-0";
export var nestedGroup = "_br-2";
export var nestedGroupContent = "_br-b";
export var nestedGroupDepth1 = "_br-3";
export var nestedGroupDepth2 = "_br-4";
export var nestedGroupDepth3 = "_br-5";
export var nestedGroupEmpty = "_br-c";
export var operatorAnd = "_br-8";
export var operatorOr = "_br-9";
export var operatorToggle = "_br-7";
export var removeGroupButton = "_br-e";